export default "__VITE_ASSET__HszSfISx__"